"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatSelect = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var constants_1 = require("../../constants");
var RepeatExecuteOnSelect_1 = require("./RepeatExecuteOnSelect");
var RepeatFrequencySelect_1 = require("./RepeatFrequencySelect");
var RepeatPeriodSelect_1 = require("./RepeatPeriodSelect");
var RepeatTypeSelect_1 = require("./RepeatTypeSelect");
var RepeatSelectRender = /** @class */ (function (_super) {
    tslib_1.__extends(RepeatSelectRender, _super);
    function RepeatSelectRender(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function () { return _this.props.onChange(_this.state); };
        _this.onRepeatTypeChange = function (repeatType) {
            if (_this.state.repeatType !== repeatType) {
                _this.setState({
                    repeatExecuteOn: constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH,
                    repeatFrequency: constants_1.REPEAT_FREQUENCIES.DAY,
                    repeatPeriod: 1,
                    repeatType: repeatType,
                }, _this.onChange);
            }
        };
        _this.onRepeatPeriodChange = function (repeatPeriod) {
            if (_this.state.repeatPeriod !== repeatPeriod) {
                _this.setState({ repeatPeriod: repeatPeriod }, _this.onChange);
            }
        };
        _this.onRepeatFrequencyChange = function (repeatFrequency) {
            if (_this.state.repeatFrequency !== repeatFrequency) {
                _this.setState({ repeatFrequency: repeatFrequency }, _this.onChange);
            }
        };
        _this.renderRepeatExecuteOn = function () {
            var startDate = _this.props.startDate;
            var _a = _this.state, repeatExecuteOn = _a.repeatExecuteOn, repeatFrequency = _a.repeatFrequency;
            if (repeatFrequency !== constants_1.REPEAT_FREQUENCIES.MONTH) {
                return null;
            }
            return (React.createElement(RepeatExecuteOnSelect_1.RepeatExecuteOnSelect, { repeatExecuteOn: repeatExecuteOn, startDate: startDate, onChange: _this.onRepeatExecuteOnChange }));
        };
        _this.onRepeatExecuteOnChange = function (repeatExecuteOn) {
            if (_this.state.repeatExecuteOn !== repeatExecuteOn) {
                _this.setState({ repeatExecuteOn: repeatExecuteOn }, _this.onChange);
            }
        };
        var repeatExecuteOn = props.repeatExecuteOn, repeatFrequency = props.repeatFrequency, repeatPeriod = props.repeatPeriod, repeatType = props.repeatType;
        _this.state = {
            repeatExecuteOn: repeatExecuteOn,
            repeatFrequency: repeatFrequency,
            repeatPeriod: repeatPeriod,
            repeatType: repeatType,
        };
        return _this;
    }
    RepeatSelectRender.prototype.render = function () {
        var _a = this.props, label = _a.label, startDate = _a.startDate;
        var repeatType = this.state.repeatType;
        return (React.createElement("div", { className: "gd-input-component gd-schedule-email-dialog-repeat" },
            React.createElement("label", { className: "gd-label" }, label),
            React.createElement("div", null,
                React.createElement(RepeatTypeSelect_1.RepeatTypeSelect, { repeatType: repeatType, startDate: startDate, onChange: this.onRepeatTypeChange }),
                this.renderCustomRepeat())));
    };
    RepeatSelectRender.prototype.renderCustomRepeat = function () {
        var intl = this.props.intl;
        var _a = this.state, repeatFrequency = _a.repeatFrequency, repeatPeriod = _a.repeatPeriod, repeatType = _a.repeatType;
        if (repeatType !== constants_1.REPEAT_TYPES.CUSTOM) {
            return null;
        }
        return (React.createElement("div", { className: "gd-schedule-email-dialog-repeat-custom" },
            React.createElement("span", { className: "gd-schedule-email-dialog-repeat-every" }, intl.formatMessage({
                id: "dialogs.schedule.email.repeats.every",
            })),
            React.createElement(RepeatPeriodSelect_1.RepeatPeriodSelect, { repeatPeriod: repeatPeriod, onChange: this.onRepeatPeriodChange }),
            React.createElement(RepeatFrequencySelect_1.RepeatFrequencySelect, { repeatFrequency: repeatFrequency, repeatPeriod: repeatPeriod, onChange: this.onRepeatFrequencyChange }),
            React.createElement("div", { className: "break-the-row" }),
            this.renderRepeatExecuteOn()));
    };
    return RepeatSelectRender;
}(React.PureComponent));
exports.RepeatSelect = react_intl_1.injectIntl(RepeatSelectRender);
//# sourceMappingURL=RepeatSelect.js.map